import React from 'react';

export function RefreshIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6663 7.9987C14.6663 11.6787 11.6797 14.6654 7.99967 14.6654C4.31967 14.6654 2.07301 10.9587 2.07301 10.9587M2.07301 10.9587H5.08634M2.07301 10.9587V14.292M1.33301 7.9987C1.33301 4.3187 4.29301 1.33203 7.99967 1.33203C12.4463 1.33203 14.6663 5.0387 14.6663 5.0387M14.6663 5.0387V1.70536M14.6663 5.0387H11.7063"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
